import { v4 as uuidv4 } from 'uuid';

export const generateBoardId = () => {
  return uuidv4().replace(/-/g, '').substring(0, 16);
};

export const exportBoardToJSON = (boardState) => {
  const dataStr = JSON.stringify(boardState, null, 2);
  const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
  
  const exportFileDefaultName = 'board.json';
  
  const linkElement = document.createElement('a');
  linkElement.setAttribute('href', dataUri);
  linkElement.setAttribute('download', exportFileDefaultName);
  linkElement.click();
};

export const importBoardFromJSON = () => {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    
    input.onchange = (event) => {
      const file = event.target.files[0];
      if (!file) {
        reject(new Error('No file selected'));
        return;
      }
      
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const boardData = JSON.parse(e.target.result);
          
          // Validate JSON structure
          if (!boardData.board_id || !Array.isArray(boardData.stickers) || !Array.isArray(boardData.connectors)) {
            reject(new Error('Invalid board JSON format'));
            return;
          }
          
          resolve(boardData);
        } catch (error) {
          reject(new Error('Failed to parse JSON file'));
        }
      };
      
      reader.onerror = () => {
        reject(new Error('Failed to read file'));
      };
      
      reader.readAsText(file);
    };
    
    input.click();
  });
};
